export default "__VITE_ASSET__DEwPpZuc__"